module.exports = __webpack_public_path__ + "static/img/brees-2005-top-image.341f256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-top-image.jpg
// module id = 0i6a
// module chunks = 1